module.exports = __webpack_public_path__ + "assets/img/btn-back-9a452341.png";